import { render } from "./licence_detail.vue?vue&type=template&id=3aa22424&scoped=true&ts=true"
import script from "./licence_detail.vue?vue&type=script&lang=ts"
export * from "./licence_detail.vue?vue&type=script&lang=ts"

import "./licence_detail.vue?vue&type=style&index=0&id=3aa22424&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa22424"]])

export default __exports__